import { motion } from "framer-motion";
import { FaBuilding, FaCheckCircle, FaClock, FaRegHandshake, FaShieldAlt, FaTools, FaUsers, FaWhatsapp } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import fire from '../assets/abtfire.jpg';
import heroImg from '../assets/building.jpg';
import herobg from '../assets/fum1.webp';
import values from '../assets/homew.webp';
import mission from '../assets/mission.jpeg';
import vision from '../assets/vision.jpg';
import ClientsPartners from '../components/ClientsPartners';


const features = [
  {
    icon: <FaRegHandshake />,
    title: "Trusted Partnerships",
    description:
      "We build lasting relationships through transparency, reliability, and consistent performance.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Safety & Compliance",
    description:
      "We follow strict safety standards across construction, fire protection, and operational environments.",
  },
  {
    icon: <FaTools />,
    title: "Skilled Expertise",
    description:
      "Our multidisciplinary team delivers quality workmanship and smart, practical solutions.",
  },
  {
    icon: <FaClock />,
    title: "Reliable Delivery",
    description:
      "We plan carefully and execute efficiently to deliver projects on time and on budget.",
  },
  {
    icon: <FaUsers />,
    title: "Client-Centered Approach",
    description:
      "We listen, adapt, and collaborate closely to meet your unique needs and expectations.",
  },
  {
    icon: <FaBuilding />,
    title: "Integrated Services",
    description:
      "From construction and fire safety to ICT, security, and pest control—we provide complete solutions under one roof.",
  },
];


const items = [
  {
    title: "Mission",
    description:
      "To deliver reliable construction and civil works, fire safety solutions, ICT & security systems, and professional pest control services that meet the highest standards of safety, quality, and efficiency.",
    image: mission,
    imageFirst: false,
  },
  {
    title: "Vision",
    description:
      "To become a trusted leader in integrated construction, safety, technology, and environmental protection solutions across Tanzania and beyond.",
    image: vision,
    imageFirst: true,
  },
  {
    title: "Values",
    description:
      "We are driven by integrity, professionalism, safety, and customer focus—building long-term partnerships through consistent quality and dependable service.",
    image: values,
    imageFirst: false,
  },
];



function AboutUs() {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center mb-10"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl  font-bold mb-4">
            About JIGHULUKE
          </h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white cursor-pointer">
              Home
            </Link>
            <span>/</span>
            <Link to="/about" className="text-gray-300 underline hover:text-white cursor-pointer">
              About Us
            </Link>
          </div>
        </div>
      </section>

      {/* About Content Section */}
      <section className="w-full pb-16 bg-white mb-10">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-stretch">

          {/* Left Side - Images */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative flex h-full"
          >
            <div className="relative w-full h-full">
              <img
                src={heroImg}
                alt="Construction work"
                loading="lazy"
                className="rounded-lg shadow-lg w-[90%] h-full object-cover"
              />
              <img
                src={fire}
                alt="Team discussion"
                loading="lazy"
                className="absolute top-10 right-14 h-1/2 translate-x-1/3 w-1/2 rounded-lg border-8 border-white shadow-lg"
              />

              {/* Label */}
              <div className="absolute -bottom-10 left-0 bg-secondary px-6 py-4 text-white font-bold text-lg shadow-lg">
                ELEVATE PROFILE
              </div>
            </div>
          </motion.div>

          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center"
          >
            <p className="uppercase tracking-widest text-sm font-semibold text-gray-500 mb-2">
              Engineering Company
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-4">
              Transform Your Vision into Reality.
            </h2>
            <p className="text-gray-600 mb-6">
              our team ensures every project is delivered safely, efficiently, and with excellence.
              We combine expertise, quality materials, and modern equipment to bring every project to life, on time and within budget,
              making your vision a reality.
            </p>

            {/* Bullet Points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {[
                "Construction Services",
                "Fire Safety Solutions",
                "ICT & Security Solutions",
                "Pest & Fumigation Services",
              ].map((point, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.2 }}
                  viewport={{ once: true }}
                  className="flex items-center gap-2"
                >
                  <FaCheckCircle className="text-primary" />
                  <span className="font-semibold text-gray-800">{point}</span>
                </motion.div>
              ))}
            </div>

            {/*  Button */}
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-6 py-3 bg-primary text-secondary font-medium rounded-md transition-all w-max"
            >
              Contact Us
              <span className="bg-white p-2 rounded-full flex items-center justify-center">
                <HiArrowRight className="w-5 h-5 text-black" />
              </span>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* vision and mission section */}
      <section className="py-16 bg-secondary/90">
        <div className="max-w-6xl mx-auto px-6">
          {/* Header */}
          <motion.h2
            className="text-3xl md:text-4xl font-bold mb-12 text-center text-white"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Our Mission & Vision
          </motion.h2>

          {/* Content */}
          <div className="flex flex-col md:flex-row gap-12">
            {items.map((item, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-start md:w-1/3 gap-6"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >

                {item.imageFirst && (
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="w-3/4 h-40 object-cover rounded-lg shadow-md mb-6 hidden md:block"
                  />
                )}

                <div className="flex items-start gap-4">
                  <div className="w-1 bg-primary h-full"></div>
                  <div>
                    <p className="text-xl font-semibold text-primary">{item.title}</p>
                    <p className="text-gray-100 mt-1 text-sm md:text-base">{item.description}</p>
                  </div>
                </div>


                {!item.imageFirst && (
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="w-3/4 h-40 object-cover rounded-lg shadow-md mt-6"
                  />
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>


      <section className="py-16 bg-gray-50 mb-10">
        <div className="max-w-6xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="uppercase text-primary font-semibold tracking-wide mb-2">Why Choose Us</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">What Sets Us Apart</h2>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="group flex flex-col items-start gap-4 p-6 bg-white rounded-lg shadow 
             hover:shadow-lg hover:bg-secondary transition-all"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <span className="bg-secondary text-primary p-3 rounded-full inline-flex items-center justify-center text-xl 
                   group-hover:bg-primary group-hover:text-secondary transition-colors">
                  {feature.icon}
                </span>
                <div>
                  <p className="text-xl font-semibold text-gray-800 group-hover:text-white transition-colors">{feature.title}</p>
                  <p className="text-gray-600 mt-1 text-sm group-hover:text-gray-200 transition-colors">{feature.description}</p>
                </div>
              </motion.div>

            ))}
          </div>
        </div>
      </section>

      <section className="bg-secondary w-full py-16 mb-10">
        <div className="mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-8 px-6 text-white">

          {/* Left Side */}
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to Start Your Project?
            </h1>
            <p className="text-lg text-gray-200">
              From construction and fire safety to ICT, security, and pest control —
              our team is ready to support your needs.
            </p>

            {/* WhatsApp Number Link */}
            <a
              href="https://wa.me/255700000000"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 mt-6  px-6 py-3 rounded-lg font-semibold shadow  transition"
            >
              <FaWhatsapp className="w-6 h-6" />
              <span>+255 700 000 000</span>
            </a>
          </div>

          {/* Vertical Divider */}
          <div className="hidden md:block w-px bg-gray-400 h-40"></div>

          {/* Right Side */}
          <div className="flex-1 text-center md:text-left">
            <p className="text-lg text-gray-200 mb-4 hidden md:block">
              Whether you’re planning a new build, upgrading safety systems,
              improving security, or managing pests, we’re here to help.
            </p>

            <Link
              to="/quote"
              className="inline-flex items-center gap-3 px-6 py-3 bg-primary hover:bg-primary/60 text-white font-medium rounded-md transition-all"
            >
              Get a Free Quote

            </Link>
          </div>
        </div>
      </section>

      <ClientsPartners />


    </div>
  );
}

export default AboutUs;
